/* eslint-disable max-len, no-extra-parens */
import { Col, Container, Row } from "react-bootstrap";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import Helmet from "react-helmet";
import { loadStripe } from "@stripe/stripe-js";
import { useNavigate } from "react-router";

import MoneyFormat from "../components/MoneyFormat";
import PaymentForm from "./PaymentForm";
import PromoCodeInput from "./PromoCodeInput";
import SignUpStepIndicator from "./SignUpStepIndicator";
import { useUser } from "../UserContext";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
const options = {
	appearance: {
		theme: "stripe",
		variables: {
			colorPrimary: "#e1a605",
			colorText: "#3c2f2f"
		}
	}
};

const Payment = () => {
	const { eqqoOptions, user } = useUser();
	const navigate = useNavigate();
	// This step of sign-up requires auth
	useEffect(() => {
		if (!user) {
			navigate("/sign-in");
		}
	}, []);

	const [promoCode, setPromoCode] = useState(null);
	const eqqoPrice = useMemo(() => {
		if (promoCode?.amount_off) {
			const originalPrice = parseInt(eqqoOptions?.profile_price, 10) * 100;
			return Math.max(0, originalPrice - promoCode?.amount_off) / 100;
		}
		if (promoCode?.percent_off) {
			const originalPrice = parseInt(eqqoOptions?.profile_price, 10) * 100;
			return Math.max(0, originalPrice * (1 - (promoCode?.percent_off / 100))) / 100;
		}
		return eqqoOptions?.profile_price;
	}, [eqqoOptions, promoCode]);
	const handlePromoCode = useCallback((code) => {
		setPromoCode(code);
	}, []);

	return (
		<Row as="main" className="sign-up">
			<Helmet>
				<title>
					{"Account Payment"}
				</title>
			</Helmet>

			<Col className="create-account flow" fluid="true">
				<div className="d-flex flex-column align-items-center flex-md-row justify-content-md-between wrapper w-100">
					<img
						alt="LOGO" className="logo" height="152" src="/eqqo_logo_blue.png"
						width="472"
					/>
					<SignUpStepIndicator current={3} />
				</div>
				<Container className="bg-white wrapper">
					<h1>Account Payment</h1>
					<hr />
					<h2 className="mb-2">Total</h2>
					<p className="mb-4 total-due">
						<MoneyFormat value={eqqoPrice} />
					</p>
					{/* Add Promo Code field*/}
					<PromoCodeInput onSuccess={handlePromoCode} />
					<hr />
					<Elements options={options} stripe={stripePromise}>
						<PaymentForm promoCode={promoCode} />
					</Elements>
				</Container>
			</Col>
		</Row>
	);
};

export default Payment;
